<template>
    <el-dialog
        :visible="visible"
        ref="DetailDialog"
        :modal-append-to-body="false"
        :close-on-click-modal="false"
        class="reconciliation-accounting-edit-dialog ah-detail-dialog"
        top="10vh"
        width="500px"
        append-to-body
        @open="onOpen"
        @close="onClose()"
    >
        <template slot="title">
            <span v-if="!form.sno">新增統制科目</span>
            <span v-else>編輯統制科目</span>
        </template>
        <div class="ah-page">
            <div class="ah-container">
                <el-form ref="form" :model="form" :rules="rules" v-loading="isLoading" class="accounting-setting-edit-dialog" label-position="top">
                    <div class="first-form-row">
                        <el-form-item prop="gccno" label="統制科目代號">
                            <el-input v-model="form.gccno" placeholder="請輸入"></el-input>
                        </el-form-item>
                        <el-form-item prop="gccnam" label="統制科目名稱（中文）">
                            <el-input v-model="form.gccnam" placeholder="請輸入"></el-input>
                        </el-form-item>
                    </div>
                    <el-form-item prop="gccnaM_E" label="統制科目名稱（英文）">
                        <el-input v-model="form.gccnaM_E" placeholder="請輸入"></el-input>
                    </el-form-item>
                    <el-form-item prop="dC_TYP" label="科目屬性">
                        <el-radio-group v-model="form.dC_TYP" size="small" class="dc-selector">
                            <el-radio :label="1" class="radio-option">
                                <div class="dc-option d-option">
                                    <div>借</div>
                                </div>
                            </el-radio>
                            <el-radio :label="2" class="radio-option">
                                <div class="dc-option c-option">
                                    <div>貸</div>
                                </div>
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-if="isGaapShow" prop="gaap" label="資產負債表項目">
                        <el-select v-model="form.gaap" placeholder="請輸入">
                            <el-option v-for="item in gaapList" :key="item.value" :label="item.label" :value="item.value" />
                        </el-select>
                    </el-form-item>
                </el-form>
                <span class="dialog-footer">
                    <el-button v-if="form.sno" v-loading="isSubmitting" type="danger" :disabled="form.defaultAccount" @click="onDelete">刪除</el-button>
                    <div v-else />
                    <div class="button-set">
                        <el-button v-loading="isSubmitting" @click="onClose()">取消</el-button>
                        <el-button v-if="!form.sno" v-loading="isSubmitting" type="primary" @click="onAdd">確定</el-button>
                        <el-button v-else v-loading="isSubmitting" type="primary" @click="onUpdate">確定</el-button>
                    </div>
                </span>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import { gaapList } from '@/assets/commonData/options';

export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Object,
            default: null,
        },
        typ: {
            type: Number,
            default: 0,
        },
        isGaapShow: Boolean,
    },
    data() {
        const gccnoValidator = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('請輸入統制科目代號'));
            } else if (value.match(/^[1-9][0-9][0-9][0-9]$/) === null) {
                callback(new Error('請輸入有效的統制科目代號'));
            } else {
                callback();
            }
        };

        return {
            isLoading: false,
            isSubmitting: false,

            gaapList,

            form: {
                sno: 0,
                gccno: '',
                gccnam: '',
                gccnaM_E: '',
                dC_TYP: 1,
                gaap: '',
                defaultAccount: false,
            },
            rules: {
                gccno: [{ required: true, validator: gccnoValidator, trigger: 'blur' }],
                gccnam: [{ required: true, message: '請輸入統制科目名稱（中文）', trigger: 'blur' }],
                dC_TYP: [{ required: true, message: '請選擇借/貸選項', trigger: 'change' }],
                gaap: [{ required: true, message: '請選擇資產負債表項目', trigger: 'change' }],
            },
        };
    },
    methods: {
        async onOpen() {
            try {
                this.isLoading = true;

                this.form.sno = this.data.sno;
                this.form.gccno = this.data.gccno;
                this.form.gccnam = this.data.gccnam;
                this.form.gccnaM_E = this.data.gccnaM_E;
                this.form.dC_TYP = this.data.dC_TYP === undefined ? 1 : this.data.dC_TYP;
                this.form.gaap = this.data.gaap;
                this.form.defaultAccount = this.data.defaultAccount;

                this.$nextTick(() => {
                    this.$refs.form.clearValidate();
                });
            } finally {
                this.isLoading = false;
            }
        },

        onAdd() {
            try {
                this.isSubmitting = true;
                this.$refs.form.validate(async (valid) => {
                    if (valid) {
                        await this.$api({
                            url: '/ReconciliationAccount/New',
                            method: 'POST',
                            data: {
                                ...this.form,
                                typ: +this.form.gccno[0],
                            },
                        });
                        this.$message.success(`${this.form.gccno} 科目已新增`);
                        this.onClose(this.form.gccno);
                    }
                });
            } finally {
                this.isSubmitting = false;
            }
        },
        onUpdate() {
            try {
                this.isSubmitting = true;
                this.$refs.form.validate(async (valid) => {
                    if (valid) {
                        if (+this.form.gccno[0] !== this.typ) {
                            await this.$confirm(`送出修改後此統治科目的類型將會從${this.typ}更新為${+this.form.gccno[0]}`, {
                                confirmButtonText: '確定',
                                cancelButtonText: '取消',
                            });
                        }

                        await this.$api({
                            url: '/ReconciliationAccount/Update',
                            method: 'POST',
                            data: {
                                ...this.form,
                                typ: +this.form.gccno[0],
                            },
                        });
                        this.$message.success(`${this.form.gccno} 科目已儲存`);
                        this.onClose(true);
                    }
                });
            } catch (e) {
                console.log(e);
            } finally {
                this.isSubmitting = false;
            }
        },
        async onDelete() {
            try {
                this.isSubmitting = true;

                await this.$confirm(`確定要刪除此統制科目 ${this.form.gccno}？`, {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });

                await this.$api({
                    url: '/ReconciliationAccount/Delete',
                    method: 'DELETE',
                    data: { sno: this.form.sno },
                });
                this.$message.success(`${this.form.gccno} 科目已刪除`);
                this.onClose(true);
            } finally {
                this.isSubmitting = false;
            }
        },

        onClose(refresh) {
            this.$emit('close', refresh);
        },
    },
};
</script>

<style lang="scss">
.reconciliation-accounting-edit-dialog {
    .ah-container {
        margin-top: 30px;
    }
    .first-form-row {
        display: flex;
        > :first-child {
            width: 120px;
            margin-right: 10px;
        }
        > :last-child {
            flex: 1;
        }
    }

    .radio-option {
        display: flex;
        align-items: center;
    }

    .dc-selector {
        display: flex;
    }
    .dc-option {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 25px;
        color: #fff;
        &.d-option {
            background-color: #f55c5c;
        }
        &.c-option {
            background-color: #56c500;
        }
    }

    .dialog-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
}
</style>
